export const errorsConvertType = value => {
  const text =
    {
      "Error! Product not found!": "Esse produto não existe.",
      "Error! More than one product found!": "Mais de um produto encontrado."
    }[value] || false;
  return text;
};
